module.exports = __webpack_public_path__ + "img/forbidden.64d971cd.svg";